// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","v3-avisos":"SectionHero_v3-avisos__gr76I","v3-negocios":"SectionHero_v3-negocios__jlA25"};